module.exports = __webpack_public_path__ + "static/media/component-misfire-monitor.0f69db10.svg";